export function registrationLabel(eventRegistrationId: number | null, competitorName: string): string {
    return eventRegistrationId !== null && eventRegistrationId !== 0 ? `#${eventRegistrationId} ${competitorName}` : competitorName;
}
